export function saveUser(status) {
  return dispatch => {
    dispatch({type: 'CHANGE_STATUS', payload: status});
  };
}
